export const lg_menu_mainpage_bottom_policy = {
        lg_menu_mainpage_bottom_policy_th: [
       ["mdi-lock", "นโยบายความปลอดภัย", "secureity-policy"],
        ["mdi-earth", "ภาษาไทย", "switch-language"],
       
      ],
          lg_menu_mainpage_bottom_policy_en: [
        ["mdi-lock", "Security Policy", "secureity-policy"],
        ["mdi-earth", "English", "switch-language"],
    
      ],
  };
  